import ButtonVue from '../ButtonVue.vue' 

new Vue({
    el: '#app',
    components: {
        ButtonVue,
    },

    vuetify: new Vuetify(),
    i18n,
    data: function () {
        return {
            dialogNotYet: false
        }
    },
    methods: {
    }
});